import {
  GET_ALL_SHORTLIST_DETAILS,
  GET_ALL_SHORTLIST_DETAILS_FAIL,
  GET_ALL_SHORTLIST_DETAILS_SUCCESS,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  successMessage: null,
  shortlistDetailsData: null,
};

const shortlistDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_SHORTLIST_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_SHORTLIST_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        shortlistDetailsData: action.payload,
      };
    case GET_ALL_SHORTLIST_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default shortlistDetailsReducer;
